import { useShouldShowStaffView } from "../../../StaffViewToggle/useShouldShowStaffView";
import { SiteTasksBox } from "../../components/SiteTasksBox";
import { updateStepStatus } from "../../updateStepStatus";
import { OperatorChangeProcess } from "../OperatorChangeProcess/OperatorChangeProcess";
import type { OperatorChange } from "../OperatorChanges.types";

interface OperatorChangeTaskListProps {
  operatorChanges: Array<OperatorChange>;
  projectId: string | undefined;
  isUpdating: boolean;
  onUpdateProcess: (operatorChange: OperatorChange) => Promise<void>;
}

function OperatorChangeTaskList({
  operatorChanges,
  projectId,
  isUpdating,
  onUpdateProcess
}: OperatorChangeTaskListProps) {
  const { shouldShowStaffView } = useShouldShowStaffView();

  return (
    <SiteTasksBox title="Betreiberwechsel">
      {operatorChanges.map((operatorChange) => (
        <OperatorChangeProcess
          isUpdating={isUpdating}
          key={operatorChange.id}
          operatorChange={operatorChange}
          projectId={projectId}
          shouldShowStaffView={shouldShowStaffView}
          onUpdateStepStatus={(change, step, status) =>
            updateStepStatus(change, step, status, onUpdateProcess)
          }
        />
      ))}
    </SiteTasksBox>
  );
}

export { OperatorChangeTaskList, OperatorChangeTaskListProps };
